import React from "react";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "../ui/accordion";
import { FAQ_ITEMS } from "../../data/landing";
import { SectionEyebrow } from "./Primitives";

export default function FAQ() {
  return (
    <section id="faq" className="relative py-20 lg:py-28">
      <div className="max-w-[1600px] w-full mx-auto px-4 sm:px-6 md:px-10 lg:px-12">
        <div className="max-w-6xl mx-auto">
          <div className="text-center">
            <SectionEyebrow>FAQ</SectionEyebrow>
            <h2 className="mt-4 font-display text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-extrabold tracking-tight text-gray-900">
              Questions, answered.
            </h2>
          </div>
          <Accordion type="single" collapsible className="mt-12 space-y-3" data-testid="faq-accordion">
            {FAQ_ITEMS.map((it, i) => (
              <AccordionItem
                key={i}
                value={`item-${i}`}
                className="rounded-2xl border border-gray-100/80 bg-white/80 glass transition-all duration-300 px-5 data-[state=open]:shadow-[0_8px_28px_rgba(0,0,0,0.05)]"
                data-testid={`faq-item-${i}`}
              >
                <AccordionTrigger className="text-left text-base md:text-lg font-semibold text-gray-900 hover:no-underline py-5">
                  {it.q}
                </AccordionTrigger>
                <AccordionContent className="text-gray-600 leading-relaxed pb-5">
                  {it.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>
      </div>
    </section>
  );
}
